import React from 'react';

const NoPermissions = ({ code, title, instruction }) => (
  <div>
    <h3 style={{ textAlign: 'center' }}>
      {title || 'Xin lỗi, Bạn không có quyền truy cập vào đây'}
    </h3>
    {instruction ?? (
      <p style={{ textAlign: 'center' }}>
        Vui lòng lòng liên hệ với quản trị viên để có quyền truy cập
      </p>
    )}
    {code && <p className="httpCode">HTTP {code}</p>}
  </div>
);

export default NoPermissions;
